import React from 'react'
import { Button, Col, Divider, Flex, Image, Modal, Row, Space, Typography } from 'antd'
import { CalendarOutlined, CheckOutlined, CloseCircleOutlined, DollarOutlined, EnvironmentOutlined } from '@ant-design/icons'

const { Title, Text } = Typography

const JobDetailModal = ({visible,onClose}) => {

    const data = [
        {
            title:'Immediate Start - Paid Research',
            desc:[
                `If the thought of participating in group discussions and voicing your opinion about new consumer products, while being compensated to do so, gets you excited...we'd love to have you apply while spots are still available.`,
                `If the thought of participating in group discussions and voicing your opinion about new consumer products, while being compensated to do so, gets you excited...we'd love to have you apply while spots are still available.`,
                `If the thought of participating in group discussions and voicing your opinion about new consumer products, while being compensated to do so, gets you excited...we'd love to have you apply while spots are still available.`
            ],
            id: 1,
        },
        {
            title:'Compensation',
            desc:[
                `£55 - £120 (per 1 hour session)`,
                `£250 - £700 (multi-session studies)`
            ],
            id: 2,
        },
        {
            title:'Responsibilities',
            desc:[
                `Show up at least 10 mins before the discussion start time.`,
                `Participate by completing written and oral instructions.`,
                `Complete written survey provided for each panel.`,
                `MUST actually use products and/or services, if provided. Then be ready to discuss PRIOR to the meeting date.`,
            ],
            id: 3,
        },
        {
            title:'Requirements',
            desc:[
                `Must have either a smart-phone with a working camera or web cam on desktop/laptop.`,
                `Must have access to a fast and reliable internet connection.`,
                `Desire to fully take part in one or several of the given topics`,
                `Ability to read, understand, and follow oral and written instructions.`,
                `Data entry clerk experience is not needed but can be a bonus`,
            ],
            id: 4,
        },
        {
            title:'Job Benefits',
            desc:[
                `Must have either a smart-phone with a working camera or web cam on desktop/laptop.`,
                `Must have access to a fast and reliable internet connection.`,
                `Desire to fully take part in one or several of the given topics`,
                `Ability to read, understand, and follow oral and written instructions.`,
                `Data entry clerk experience is not needed but can be a bonus`,
            ],
            id: 5,
        },
        {
            title:'Skills',
            desc:[
                `Data Entry`,
                `Focus Groups`,
                `General Administration`,
                `Market Research`,
                `Working Remotely`,
            ],
            id: 5,
        },
    ]

  return (
    <div>
        <Modal 
            title={null}
            centered
            open={visible} 
            onCancel={onClose}
            closeIcon={false}
            className='modal-cs'
            footer={null}
            width={600}
        >
            <div className='header-modal position-relative'>
                <img src='/assets/images/brown-bg.jpg' preview={false} />
                <Button className='border0 bg-transparent p-0 btnclose' onClick={onClose}>
                    <CloseCircleOutlined className='text-white' style={{fontSize: 30}} />
                </Button>
            </div>
            <div className='content-modal'>
                <Row gutter={[16, 16]}>
                    <Col xs={{ span: 20 }} sm={{ span: 20 }} md={{ span: 19 }} lg={{ span: 20 }}>
                        <Space size={5} wrap>
                            <span className='custom-badge gray-bg fs-12 text-white'>Onsite</span>
                            <span className='custom-badge brown-bg fs-12 text-white'>Posted on Nextdoor Pros</span>
                        </Space>
                    </Col>
                    <Col xs={{ span: 4 }} sm={{ span: 4 }} md={{ span: 4 }} lg={{ span: 4 }}>
                        <Flex justify='end' gap={10}>
                            <Image src='assets/icons/heart.png' width={30} height={30} preview={false} />
                        </Flex>
                    </Col>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 18 }} lg={{ span: 18 }}>
                        <Flex gap={10} align='center' className=' w-100 '>
                            <Image src={'assets/images/logo1.png'} width={45} height={45} preview={false} />
                            <Title level={4} className='m-0'>Web Developer</Title>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Flex justify='space-between' wrap>
                            <Flex vertical className='' gap={4}>
                                <Text className='fs-14'><EnvironmentOutlined /> Islamabad</Text>
                                <Text className='fs-14'><CalendarOutlined /> Dec 12, 2024</Text>
                            </Flex>
                            <Flex vertical className='mt-2' gap={4}>
                                <Title level={5} className='m-0'>Heave Stack</Title>
                                <Text className='fs-14'><DollarOutlined /> $700 month</Text>
                            </Flex>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Flex>
                            <Button className="btn fs-14 fw-400 p-2">
                                Apply Now
                            </Button>
                        </Flex>
                    </Col>
                    <Col span={24}>
                        <Divider className='my-2' style={{background:'gray'}} />
                    </Col>
                    <Col span={24}>
                        <div className='scroll-md px-2'>
                            {
                                data?.map((details,index)=>
                                    <Flex vertical gap={5} className='mb-2' key={index}>
                                        <Title level={4} className='m-0'>
                                            {
                                                details?.title
                                            }
                                        </Title>
                                        {
                                            details?.desc?.map((innertext,i)=>
                                                <Flex gap={4} align='flex-start'>
                                                    {
                                                        details.id !== 1 &&
                                                        <CheckOutlined style={{marginTop:5}} />
                                                    }
                                                    <Text key={i} className='fs-14 text-justify'>
                                                        {
                                                            innertext
                                                        }
                                                    </Text>
                                                </Flex>
                                            )
                                        }
                                    </Flex>
                                )
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
    </div>
  )
}

export {JobDetailModal}